/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ERRORS } from './Error.constants';
import { ErrorWithHttpStatusCode } from './ErrorWithHttpStatusCode';

/**
 * Not found error (404).
 * @export
 * @class NotFoundError
 * @extends {ErrorWithHttpStatusCode}
 */
export class NotFoundError extends ErrorWithHttpStatusCode {
  constructor(details: string, message = ERRORS.notFound.name) {
    super(ERRORS.notFound.code, message, details);
  }
}
